<template>
    <div @click="hideSearch()" id="chat_container" class="chat__bg no-scroll-content chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0" :class="{'sidebar-spacer--wide': (chatSidebar && windowWidth > 1200)}">
        <!-- Шапка диалога -->
        <div class="chat__navbar">
            <ChatNavbar
                v-if="windowWidth < 1200 || openDialog"
                :isSidebarCollapsed="!chatSidebar"
                :chatData="openDialog" />
        </div>
        <template v-if="openDialog">

            <!-- Тело диалога -->
            <div :class="['chat-content-scroll-area border border-solid d-theme-border-grey-light', (emptyMessage || !openDialog.is_active) && 'flex item-center justify-center items-center']">
                <template v-if="!openDialog.is_active">
                    <div class="chat_message_info border shadow-md border-solid border-transparent bg-white p-1 lg:p-3 mt-3 mb-3 text-sm">
                        {{$t('chat_administration_excluded_you')}}
                    </div>
                </template>
                <template v-else>
                    <infinite-loading
                        v-bind:distance="10"
                        :identifier="`${ openDialog.id }${ openDialog.downKey ? openDialog.downKey : '' }`"
                        direction="top"
                        spinner="spiral"
                        @infinite="upScrollHandler">
                        <div slot="no-more"></div>
                        <div slot="no-results"></div>
                    </infinite-loading>

                    <div class="chat__log m-1 lg:m-8" ref="chatLog">
                        <template v-if="currentMessage">
                            <div v-for="(item, index) in currentMessage.value" :key="`${ item.id }_${ index }`" class="flex items-start mt-3">
                                <ChatMessage :replySearch="replySearch" :replyMethod="messageReply" :user="user" :messageItem="item" />
                            </div>
                        </template>
                    </div>

                    <infinite-loading
                        v-if="currentMessage && currentMessage.prev && currentMessage.prev.length"
                        v-bind:distance="10"
                        :identifier="`${ openDialog.id }_${ currentMessage.prev }`"
                        spinner="spiral"
                        @infinite="downScrollHandler">
                            <div slot="no-more"></div>
                            <div slot="no-results"></div>
                    </infinite-loading>

                    <div class="chat_message_info border shadow-md border-solid border-transparent bg-white p-1 lg:p-3 mt-3 mb-3 text-sm" v-if="emptyMessage">
                        <ul>
                            <template v-if="openDialog.is_public">
                                <li>- {{$t('chat_author')}} <span class="text-primary cursor-pointer" @click="$store.commit('chat/CHANGE_INFO', true)">{{openDialog.author.full_name}}</span></li>
                                <li>- {{$t('chat_author_can_rename_chat')}}</li>
                                <li>- {{$t('chat_author_can_delete_chat')}}</li>
                                <li>- {{$t('chat_author_can_remove_chat_participants')}}</li>
                                <li>- {{$t('chat_menu')}} <feather-icon @click="$store.commit('chat/CHANGE_INFO', true)" class="text-primary cursor-pointer" icon="MoreVerticalIcon" svgClasses="h-4 w-4" /> {{$t('chat_menu2')}}</li>
                                <li>- {{$t('chat_author_can_assign_remove_moderators')}}</li>
                                <li>- {{$t('chat_creator_and_moderators_can_delete_chat_messages')}}</li>
                            </template>
                            <li>- {{$t('chat_info_max')}}</li>
                            <li>- {{$t('chat_info_del')}}</li>
                            <li>- {{$t('chat_info_file_size')}}</li>
                            <li>- {{$t('chat_info_enter')}}</li>
                            <li>- {{$t('chat_info_news_str')}}</li>
                        </ul>
                    </div>

                    <transition name="slide">
                        <div v-if="fileList.length" class="file_dummy"></div>
                    </transition>
                    <transition name="slide">
                        <div v-if="replyMessage" class="reply_dummy"></div>
                    </transition>
                </template>
            </div>

            <!-- Подвал диалога -->
            <div class="chat__input flex px-2 lg:px-4 py-2 bg-white relative" v-if="openDialog.is_active">
                <div class="last_wrapper" v-if="lastMess">
                    <div class="last_mess" @click="lastMessFetch()">
                        <feather-icon class="mr-2" icon="ArrowDownIcon" svgClasses="w-3 h-3" />
                        {{$t('new_messages')}}
                    </div>
                </div>
                <transition name="slide">
                    <div class="file_nav flex item-center absolute px-4 py-1" :class="replyMessage && 'reply_padding'" v-if="fileList.length">
                        <div class="file_item relative" v-for="(item, index) in fileList" :key="index">
                            <div class="remove_file" @click="removeFile(item)">
                                <feather-icon icon="XIcon" svgClasses="w-3 h-3" />
                            </div>
                            <div v-if="item.loading" class="lds-ring"><div></div><div></div><div></div><div></div></div>
                            <template v-else>
                                <template v-if="item.image">
                                    <img :src="item.src" :alt="item.file.name" />
                                </template>
                                <template v-else>
                                    <feather-icon icon="FileIcon" svgClasses="w-8 h-8" />
                                    <div class="w-full truncate text-xs">{{item.type}}</div>
                                </template>
                            </template>
                        </div>
                    </div>
                </transition>
                <transition name="slide">
                    <div class="flex item-center justify-between reply_nav absolute px-4 py-1" v-if="replyMessage">
                        <div class="replay_nav_body">
                            <div class="text-xs">{{replyMessage.author.full_name}}</div>
                            <div v-if="replyMessage.text.length" class="replay_nav_text mt-1 text-sm" v-html="replyMessage.text"></div>
                            <div v-else class="mt-1 text-sm"><feather-icon icon="FileIcon" svgClasses="w-3 h-3" /> {{$t('file_image')}}</div>
                        </div>
                        <feather-icon class="cursor-pointer" @click="replyMessage = null" icon="XIcon" svgClasses="w-6 h-6" />
                    </div>
                </transition>
                <div class="flex-1 relative">
                    <textarea
                        @keydown="inputHandler"
                        name="message"
                        class="text_field w-full vs-inputx vs-input--input normal"
                        :placeholder="placeholder"
                        v-model="message.text"></textarea>
                    <label class="file_btn" for="message_file">
                        <feather-icon icon="PaperclipIcon" svgClasses="w-6 h-6" />
                    </label>
                    <input
                        accept=".jpg, .jpeg, .png, .gif .doc, .docx, .xlsx, .xls, .pdf, .zip, .rar, .7z, .mp3"
                        multiple
                        style="display:none;"
                        hidden v-on:change="handleFileUpload"
                        type="file"
                        id="message_file" />
                </div>
                <vx-tooltip text="ENTER">
                    <vs-button
                        @click="sendMessageHandler()"
                        icon-pack="feather"
                        icon="icon-send"
                        class="ml-2 create_mess_btn"
                        type="filled" />
                </vx-tooltip>
            </div>
        </template>
        <template v-if="!openDialog && loadChat">
            <div class="dialog_close flex flex-col items-center justify-center">
                <feather-icon icon="MessageSquareIcon" class="mb-4 bg-white p-8 shadow-md rounded-full" svgClasses="w-16 h-16" />
                <h4 @click="openContactPopup()" class=" py-2 px-4 bg-white shadow-md rounded-full cursor-pointer">
                    {{$t('create_chat')}}
                </h4>
            </div>
        </template>

        <ChatInfo v-if="openDialog" />

        <vs-popup class="popup_chat_name" :title="$t('delete_chat')" :active.sync="deletePopup">
            <div class="flex justify-center">
                <vs-button @click="deletePopup = false" class="mx-1" color="primary" type="border">
                    {{$t('cancel')}}
                </vs-button>
                <vs-button @click="deleteChat()" class="mx-1 delete_loader" color="danger" type="border">
                    {{$t('remove')}}
                </vs-button>
            </div>
        </vs-popup>
    </div>
</template>

<script>
const sound = require('@/assets/audio/new_notify.mp3')
import {isFileImage, previewImage} from './utils'
import ChatNavbar from './ChatNavbar.vue'
import ChatInfo from './ChatInfo.vue'
import ChatMessage from './ChatMessage.vue'
import InfiniteLoading from 'vue-infinite-loading'
import {mapState} from 'vuex'
export default {
    props: {
        clickNotClose: Boolean
    },
    data() {
        return {
            message: {
                text: ''
            },
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.6
            },
            loading: false,
            emptyMessage: false,
            fileList: [],
            replyMessage: null,
            placeholder: this.$t('enter_your_message'),
            lastMess: false
        }
    },
    watch: {
        replyMessage(val) {
            if(val)
                this.placeholder = this.$t('reply_to_message')
            else
                this.placeholder = this.$t('enter_your_message')
        },
        openDialog(val) {
            if(this.fileList.length) {
                this.fileList.forEach(item => {
                    this.deleteFile(item.file.id)
                })
            }
            if(val) {
                this.$nextTick(() => {
                    const scrollArea = document.querySelector('.chat-content-scroll-area')
                    //const textInput = document.querySelector('.text_field')
                    scrollArea.scrollTop = scrollArea.scrollHeight

                    //if(textInput)
                    //textInput.focus()
                })
                this.fileList = []
                this.message.text = ''
                this.emptyMessage = false
                this.loading = false
            }
            this.replyMessage = null
            this.lastMess = false
        },
        deleteDialog(val) {
            let query = this.$route.query
            if(query && Number(query.id) === val.id)
                this.$router.push({name: 'chat'})
        },
        deleteUser(val) {
            let query = this.$route.query
            if(query && Number(query.id) === val.chat)
                this.$router.push({name: 'chat'})
        },
        newMessage(val) {
            if(this.openDialog && this.openDialog.id === val.chat) {
                const scrollArea = document.querySelector('.chat-content-scroll-area'),
                    currScroll = scrollArea.scrollHeight - scrollArea.scrollTop,
                    clientHeight = scrollArea.clientHeight + 200;

                if(clientHeight >= currScroll) {
                    setTimeout(() => {
                        scrollArea.scrollTop = scrollArea.scrollHeight + 600
                    }, 50)
                } else {
                    this.$store.commit('chat/ADD_MESSAGE_COUNT')
                    let checkCount = true

                    scrollArea.addEventListener("scroll", () => {
                        if(this.lastMess)
                            this.lastMess = false

                        const cScroll = scrollArea.scrollHeight - scrollArea.scrollTop,
                            cHeight = scrollArea.clientHeight + 200
                        if(cHeight >= cScroll) {
                            if(checkCount) {
                                checkCount = false
                                this.$store.commit('chat/CHANGE_MESSAGE_COUNT')
                            }
                        }
                    })
                }

                if(this.currentMessage.prev || currScroll > 800)
                    this.lastMess = true
            }
            const audio = new Audio(sound)
            audio.oncanplaythrough = () => {
                const playedPromise = audio.play()
                if (playedPromise) {
                    playedPromise.catch(() => {
                        //if (e.name === 'NotAllowedError' || e.name === 'NotSupportedError') {
                        //    console.log(e.name)
                        //}
                    }).then(() => {

                    })
                }
            }
        }
    },
    methods: {
        async replySearch(message) {
            const messageScroll = (elem) => {
                document.querySelector('.chat-content-scroll-area').scrollTop = elem.offsetTop - 10
                if (!elem.classList.contains('flashing')) {
                    elem.classList.add('flashing')
                    setTimeout(() => {
                        elem.classList.remove('flashing')
                    }, 300)
                }
            }

            try {
                const searchMessage = this.currentMessage.value.find(item => item.id === message.id)

                if(searchMessage) {
                    const elem = document.getElementById(`message_${ searchMessage.id }`)
                    messageScroll(elem)
                } else {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            container: '.chat-content-scroll-area',
                            scale: 0.6
                        })
                    })
                    await this.$store.dispatch('chat/searchMessages', message)
                    const elem = document.getElementById(`message_${ message.id }`)
                    messageScroll(elem)
                }
            } catch(e) {

            } finally {
                this.$vs.loading.close('.chat-content-scroll-area > .con-vs-loading')
            }
        },
        messageReply(message) {
            const textInput = document.querySelector('.text_field')
            if(textInput)
                textInput.focus()

            this.replyMessage = message
        },
        async deleteFile(id) {
            try {
                let formData = new FormData()
                formData.append('id', id)
                await this.$http.axiosApp.post('/app/attachment/delete/', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
            } catch(e) {

            }
        },
        checkScrollArea() {
            this.$nextTick(() => {
                let chatArea = document.querySelector('.chat-content-scroll-area')
                if(chatArea) {
                    chatArea.addEventListener('scroll', () => {
                        if(this.openDialog && this.openDialog.new_message_count > 0)
                            this.$store.commit('chat/CHANGE_MESSAGE_COUNT')
                    })
                }
            })
        },
        removeFile(file) {
            this.deleteFile(file.file.id)
            const index = this.fileList.findIndex(elem => elem.id === file.id)
            if(index !== -1)
                this.fileList.splice(index, 1)
        },
        async handleFileUpload(event) {
            const files = Object.values(event.target.files)
            if(files.length) {
                files.forEach(async (item, i) => {
                    let formData = new FormData()

                    if(10 && ((files[i].size / 1024) / 1024) >= 10 ) {
                        this.$vs.notify({
                            text: this.$t('file_size_error', {name: files[i].name, filesize: 10}),
                            color: 'warning'
                        })
                        return false
                    }

                    const id = Date.now()+Math.floor(Math.random()*Math.floor(20))+Math.random()
                    const type = isFileImage(files[i])

                    this.fileList.push({
                        image: type,
                        type: files[i].name.split('.')[1],
                        loading: true,
                        id
                    })

                    formData.append('path', files[i])

                    try {
                        const {data} = await this.$http.post('/common/upload/', formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        if(data) {
                            const index = this.fileList.findIndex(elem => elem.id === id)
                            this.fileList[index].file = data
                            if(type) {
                                previewImage(item, 60).then(async(previewDataUrl) => {
                                    this.fileList[index].src = previewDataUrl
                                    this.fileList[index].loading = false
                                })
                            } else {
                                this.fileList[index].loading = false
                            }
                        }
                    } catch(e) {

                    }
                })
            }
        },
        inputHandler(e) {
            if (e.keyCode === 13 && !e.shiftKey) {
                e.preventDefault()
                this.sendMessageHandler()
            }
        },
        async downScrollHandler($state) {
            if(this.currentMessage && !this.loading) {
                if(this.currentMessage.prev && this.currentMessage.prev.length) {
                    try {
                        this.loading = true
                        await this.$store.dispatch('chat/getMessageDownScroll')
                        if(this.currentMessage.bottomStatus)
                            $state.loaded()
                        else
                            $state.complete()
                    } catch(e) {

                    } finally {
                        this.loading = false
                    }
                } else {
                    $state.complete()
                }
            }
        },
        async lastMessFetch() {
            // Запрашиваем сообщения изначально

            if(this.currentMessage.prev) {
                try {
                    this.loading = true
                    this.$nextTick(() => {
                        this.$vs.loading({
                            container: '.chat-content-scroll-area',
                            scale: 0.6
                        })
                    })

                    await this.$store.dispatch('chat/getMessage', true)
                } catch(e) {

                } finally {
                    const scrollArea = document.querySelector('.chat-content-scroll-area')
                    scrollArea.scrollTop = scrollArea.scrollHeight
                    this.loading = false
                    this.lastMess = false
                    this.$vs.loading.close('.chat-content-scroll-area > .con-vs-loading')
                }
            } else {
                const scrollArea = document.querySelector('.chat-content-scroll-area')
                scrollArea.scrollTop = scrollArea.scrollHeight
                this.lastMess = false
            }
        },
        async upScrollHandler($state) {
            if(this.currentMessage && !this.loading) {
                // Запрашиваем сообщение при скролле
                if(this.currentMessage.next && this.currentMessage.next.length) {
                    try {
                        this.loading = true
                        await this.$store.dispatch('chat/getMessageScroll')
                        if(this.currentMessage.status)
                            $state.loaded()
                        else
                            $state.complete()
                    } catch(e) {

                    } finally {
                        this.loading = false
                    }
                } else
                    $state.complete()
            } else {
                // Запрашиваем сообщения изначально
                try {
                    this.loading = true

                    await this.$store.dispatch('chat/getMessage')

                    if(this.currentMessage && this.currentMessage.status)
                        $state.loaded()
                    else
                        $state.complete()
                } catch(e) {

                } finally {
                    const scrollArea = document.querySelector('.chat-content-scroll-area')
                    scrollArea.scrollTop = scrollArea.scrollHeight
                    if(!this.currentMessage)
                        this.emptyMessage = true
                    this.loading = false
                }
            }
        },
        async deleteChat() {
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '.delete_loader',
                        scale: 0.6
                    })
                })
                const res = await this.$store.dispatch('chat/deleteChat')
                if(res) {
                    this.$router.push({name: 'chat'})
                    this.deletePopup = false
                }
            } catch(e) {

            } finally {
                this.$vs.loading.close('.delete_loader > .con-vs-loading')
            }
        },
        openContactPopup() {
            this.$store.commit('chat/SET_CONTACT_POPUP', true)
        },
        sendMessageHandler() {
            if(this.fileList.length) {
                if(this.message.text.length) {
                    if(this.message.text.length < 1024) {
                        this.createMessage()
                    } else {
                        this.$vs.notify({
                            text: this.$t('message_max'),
                            color: 'warning'
                        })
                    }
                } else {
                    this.createMessage()
                }
            } else {
                if(this.message.text.length) {
                    if(this.message.text.length < 1024) {
                        this.createMessage()
                    } else {
                        this.$vs.notify({
                            text: this.$t('message_max'),
                            color: 'warning'
                        })
                    }
                }
            }
        },
        async createMessage() {
            try {
                this.$nextTick(() => {
                    this.$vs.loading({
                        container: '.create_mess_btn',
                        scale: 0.6
                    })
                })

                let queryParams = {
                    message: this.message,
                    attachments: []
                }

                if(this.fileList.length) {
                    this.fileList.forEach(item => {
                        queryParams.attachments.push(item.file[0].uid)
                    })
                }

                if(this.replyMessage)
                    queryParams.message_reply = this.replyMessage.id

                const res = await this.$store.dispatch('chat/createMessage', queryParams)
                if(res) {
                    this.emptyMessage = false
                    this.clearChat()
                }
            } catch(e) {

            } finally {
                this.replyMessage = null
                this.$nextTick(() => {
                    const scrollArea = document.querySelector('.chat-content-scroll-area')
                    scrollArea.scrollTop = scrollArea.scrollHeight
                })
                this.$vs.loading.close('.create_mess_btn > .con-vs-loading')
            }
        },
        clearChat() {
            this.fileList = []
            this.message = {text: ''}
        },
        hideSearch() {
            if(this.searchText.length) {
                this.$store.commit('chat/SET_SEARCH_TEXT', '')
                this.$store.commit('chat/CLEAR_SEARCH_RESULT')
            }
        }
    },
    computed: {
        ...mapState({
            openDialog: state => state.chat.openDialog,
            chatMessage: state => state.chat.chatMessage,
            user: state => state.user.user,
            resUid: state => state.chat.resUid,
            chatSidebar: state => state.chat.chatSidebar,
            newMessage: state => state.chat.newMessage,
            deleteDialog: state => state.chat.deleteDialog,
            deleteUser: state => state.chat.deleteUser,
            searchText: state => state.chat.searchText,
            windowWidth: state => state.windowWidth,
        }),
        deletePopup: {
            get() {
                return this.$store.state.chat.deletePopup
            },
            set(val) {
                this.$store.commit('chat/SET_DELETE_POPUP', val)
            }
        },
        currentMessage() {
            if(this.openDialog && this.chatMessage[this.openDialog.id])
                return this.chatMessage[this.openDialog.id]
        },
        loadChat() {
            const query = this.$route.query
            if(query && query.id)
                return false
            else
                return true
        }
    },
    components: {
        ChatNavbar,
        ChatMessage,
        ChatInfo,
        InfiniteLoading
    }
}
</script>

<style lang="scss">
.dialog_close{
    height: 100%;
}
.file_dummy{
    height: 67px;
}
.reply_dummy{
    height: 40px;
}
.slide-enter-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: ease-in;
   -webkit-transition-timing-function: ease-in;
   -o-transition-timing-function: ease-in;
   transition-timing-function: ease-in;
}

.slide-leave-active {
   -moz-transition-duration: 0.3s;
   -webkit-transition-duration: 0.3s;
   -o-transition-duration: 0.3s;
   transition-duration: 0.3s;
   -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
   transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
   max-height: 100px;
   overflow: hidden;
}

.slide-enter, .slide-leave-to {
   overflow: hidden;
   max-height: 0;
}
.file_item{
    width: 60px;
    height: 60px;
    flex-wrap: wrap;
    align-content: center;
    text-align: center;
    border-radius: 5px;
    border: 1px solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    .remove_file{
        position: absolute;
        cursor: pointer;
        top: -7px;
        right: -7px;
        width: 14px;
        height: 14px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        background: red;
    }
    &:not(:last-child){
        margin-right: 8px;
    }
}
.lds-ring {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 20px;
  height: 20px;
  border: 2px solid #000;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #000 transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.reply_nav{
    bottom: 58px;
    height: 40px;
    width: 100%;
    left: 0;
    z-index: 15;
    background: rgba(255, 255, 255, 0.8);
    .replay_nav_body{
        border-left: 2px solid #7367f0;
        padding-left: 5px;
        max-width: 96%;
        .replay_nav_text{
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }
    }
}
.file_nav{
    bottom: 58px;
    height: 67px;
    width: 100%;
    left: 0;
    z-index: 15;
    background: rgba(255, 255, 255, 0.8);
    &.reply_padding{
        bottom: 98px;
    }
}
.text_field{
    max-height: 38px;
    resize: none;
    font-family: Montserrat,Helvetica,Arial,sans-serif;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
    &:focus,
    &:hover{
        font-size: 1rem;
    }
}
.file_btn{
    position: absolute;
    right: 0px;
    top: 0px;
    height: 38px;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 0 10px;
}
.chat-content-scroll-area{
    height: calc(100% - 112px)!important;
    overflow: hidden;
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
.chat_message_info{
    cursor: default;
    li{
        word-break: break-word;
        &:not(:last-child){
            margin-bottom: 5px;
        }
    }
}
@media only screen and (min-width: 893px) {
    .chat_message_info{
        max-width: 400px;
        min-width: 300px;
    }
}
.last_wrapper{
    position: absolute;
    top: -40px;
    z-index: 10;
    left: 50%;
    margin-left: -76px;
}
.last_mess{
    position: fixed;
    background: #31c76f;
    color: #ffffff;
    font-size: 11px;
    padding: 5px 8px;
    border-radius: 30px;
    cursor: pointer;
    display: flex;
    align-items: center;
}
.delete_loader,
.create_mess_btn{
    position: relative;
    .con-vs-loading{
        position: absolute;
    }
}
</style>
